import * as React from 'react'
import { Text, Block, Button } from '$views/components'
import {
  StyledContainer,
  StyledGreenBlock,
  StyledFormContainer,
} from '$views/CaretakerRecommendation/Components/ShareSection/ShareSection.style'
import { IconWithText } from '$views/components/IconWithText'
import copyIcon from '$icons/copy.svg'
import whatsappIcon from '$icons/whatsapp.svg'
import emailIcon from '$icons/email.svg'
import { Fade } from '$views/components/Fade'
import { routeProvider } from '$utils/routeProvider'
import { tagManager } from '$infrastructure/tagManager/tagManager'

interface Props {
  shareUrl?: string
  shareEmailSubject?: string
}
interface WindowWithNativeProps extends Window {
  ReactNativeWebView?: any
}

interface NavigatorWithClipboardProps extends Navigator {
  clipboard?: any
}

export const defaultShareUrl =
  'https://cuidar.familiados.com/?utm_medium%3dreferral%26utm_source%3dfamiliados%26utm_campaign%3dpagina_reco%26utm_content%3dfooter'
export const defaultShareEmailSubject =
  'He encontrado Familiados y...¡Es la mejor App para encontrar profesionales! Mira, ¡Es genial!'

export const ShareSection: React.FC<Props> = ({ shareUrl, shareEmailSubject }) => {
  const windowsWithNativeProps: WindowWithNativeProps = window
  const [showCopyToClipboard, setShowToClipboard] = React.useState<boolean>(false)

  const getShareUrl = () => (shareUrl ? shareUrl : defaultShareUrl)

  const getShareEmailSubject = () => (shareEmailSubject ? shareEmailSubject : defaultShareEmailSubject)

  const onClickEmailShare = () => {
    tagManager.push({ event: 'fam', fam_id: 'ShareEmail' })
    window.location.assign(routeProvider.shareOnEmail(getShareEmailSubject(), getShareUrl()))
  }

  const onClickWhatsappShare = () => {
    tagManager.push({ event: 'fam', fam_id: 'ShareWhatsApp' })
    window.location.assign(routeProvider.shareOnWhatsapp(getShareUrl()))
  }

  const onClickShare = () => {
    if (windowsWithNativeProps.ReactNativeWebView) {
      tagManager.push({ event: 'fam', fam_id: 'Share' })
      windowsWithNativeProps.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: 'share',
          message: getShareUrl(),
        }),
      )
    }
  }

  const onClickCopy = () => {
    setShowToClipboard(true)
    tagManager.push({ event: 'fam', fam_id: 'ShareLink' })
    if (!windowsWithNativeProps.ReactNativeWebView) {
      const navigatorWithClipboardProps: NavigatorWithClipboardProps = navigator
      if (navigatorWithClipboardProps.clipboard) {
        navigatorWithClipboardProps.clipboard.writeText(getShareUrl())
      }
    } else {
      windowsWithNativeProps.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: 'copyToClipboard',
          text: getShareUrl(),
        }),
      )
    }

    setTimeout(() => setShowToClipboard(false), 2000)
  }

  return (
    <StyledGreenBlock>
      <StyledContainer>
        <StyledFormContainer login>
          {shareUrl ? (
            <>
              <Text title weight="bold">
                Comparte tu selección
              </Text>
              <Text marginTop="base">¿Quieres que alguien vea estos perfiles? </Text>
              <Text>¡Envíaselos y comenta lo que necesites!</Text>
              <Text marginTop="base">Elige cómo compartir 👇</Text>
            </>
          ) : (
            <>
              <Text title weight="bold">
                Compártenos
              </Text>
              <Text marginTop="base">¿Quieres compartir Familiados con un amigo o familiar?</Text>
              <Text marginTop="base">Te lo agradecerá 👏</Text>
            </>
          )}
          {!windowsWithNativeProps.ReactNativeWebView ? (
            <>
              <Block flex marginTop="small">
                <IconWithText
                  label="Whatsapp"
                  onClick={onClickWhatsappShare}
                  iconSrc={whatsappIcon}
                  backgroundColor="darkGrey"
                  iconColor="xlightGreen"
                />
                <IconWithText
                  label="Email"
                  onClick={onClickEmailShare}
                  iconSrc={emailIcon}
                  backgroundColor="darkGrey"
                  iconColor="xlightGreen"
                />
                <Block>
                  <IconWithText
                    label="Copiar"
                    onClick={onClickCopy}
                    iconSrc={copyIcon}
                    backgroundColor="darkGrey"
                    iconColor="xlightGreen"
                  />
                </Block>
              </Block>
              <Block>
                <Fade showBlock={showCopyToClipboard}>
                  <Text color="menu" marginTop="small" weight="medium">
                    🎉 Enlace copiado!
                  </Text>
                </Fade>
              </Block>
            </>
          ) : (
            <Block flex marginTop="small">
              <Button primary bordered onClick={onClickShare}>
                Compartir
              </Button>
            </Block>
          )}
        </StyledFormContainer>
      </StyledContainer>
    </StyledGreenBlock>
  )
}



// WEBPACK FOOTER //
// ./src/views/CaretakerRecommendation/Components/ShareSection/ShareSection.tsx